// extracted by mini-css-extract-plugin
export var button = "_12-0";
export var buttonContent = "_12-e";
export var buttonGroup = "_12-c";
export var dontRestrainIconWidth = "_12-a";
export var dropdownButton = "_12-b";
export var iconContainer = "_12-9";
export var lg = "_12-4";
export var md = "_12-3";
export var pending = "_12-f";
export var sm = "_12-2";
export var spinner = "_12-d";
export var squared = "_12-8";
export var wrapText = "_12-g";
export var xl = "_12-5";
export var xs = "_12-1";
export var xxl = "_12-6";
export var xxxl = "_12-7";